export default __webpack_public_path__ + "static/media/nest.abaea2b7.svg";